import { apiService } from "../axiosService";

export const getOrganisationsApi = async ({ signal } = {}) => {
  const data = await apiService.get("/organisations", { signal });
  return data;
};

export const createOrganisationApi = async (payload) => {
  const response = await apiService.post("/organisations", payload);
  return response;
};

export const updateOrganisationApi = async (payload) => {
  const response = await apiService.put(`/organisations/${payload.id}`, payload);
  return response;
};

export const deleteOrganisationApi = async (id) => {
  const response = await apiService.delete(`/organisations/${id}`);
  return response;
};
